var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ni-legend-item",class:{
		[`placement-${_vm.placement}`]: _vm.placement,
	},style:({
		'--x-shift': _vm.xShift,
	}),domProps:{"innerHTML":_vm._s(_vm.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }